export default "__VITE_ASSET__BA12sM7C__"